module.exports = __webpack_public_path__ + "img/banner.91324b5a.png";